module.exports = __webpack_public_path__ + "static/walnut-06f72faac85da6d91542a4b3ac6f54a2.svg";